<template>
  <div>
     <el-card>
      <search-form ref="searchForm" :topVisible="true" :tabData="tabData" labelWidth="120px" :searchFormData="searchFormData" @search="search" @tabChange="tabChange">
         <template #topBtn>
          <el-button type="primary" size="small" @click="handleClick('create')">{{ $t('text.add') }}</el-button>
          <el-button type="primary" size="small" @click="handleExport">{{ $t('button.orderExport') }}</el-button>
          <el-button type="primary" size="small" @click="handleInvoiceExport">{{ $t('button.invoiceExport') }}</el-button>
          <el-button type="primary" size="small" @click="handleInvoiceListingExport">{{ $t('button.invoiceListingExport') }}</el-button>
          <div class="customAmount"><span>{{`${$t('form.purchase.totalAmount')}: ${total_amount || 0}`}}</span></div>
          <div class="customAmount"><span>{{`${$t('form.purchase.totalDueAmount')}: ${total_due_amount || 0}`}}</span></div>
          <div class="customAmount"><span>{{`${$t('form.purchase.totalWaiveAmount')}: ${total_waive_amount || 0}`}}</span></div>
        </template>
      </search-form>
      <create-table :operationColWidth="150" @handleNewTab="handleNewTab($event, 'suppliersDetail')" :autoWidth="true" :operateVisible="operateVisible" ref="createTable" :loading="loading" :btnType="[]" :total_count="pageData.total_count ? pageData.total_count : 0" :current_page.sync="pageData.page" :papeSize.sync="pageData.per_page" @selectionChange="selectionChange" :topButtonVisible="true" :tableData="tableData" :tableDataItem="tableDataItem" @operate="handleClick" :pageVisible="true" :pageData="pageData" :checkBoxVisible="true" @handleSort="handleSort" @onSwitchChange="handleSwitchChange" @forwardToPage="forwardToPage">
        <template #topButton>
          <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{`${$t('text.selected')}：${selectionData.length}`}}</span>
          <allButton
          :buttonDisabled="selectionData.length < 1"
          :buttonDataItem="dropDataItem"
          class="marginRight20"
          @chooseDropItem="chooseDropItem">
          </allButton>
        </template>
        <template #rightBtn="scope">
          <el-button class="margintop10" :class="item.action === 'view' ? 'operate_view' : ''" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view/>
    <dialogEffect v-if="dialogVisible" :opereteDate="false" :todayVisible="true" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import Suppliers from './index.js'
export default Suppliers
</script>

<style lang="scss">
@import url(./index.scss);
</style>
